import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Column } from 'primereact/column'
import { TabPanel } from 'primereact/tabview'
import { Fieldset } from 'primereact/fieldset'
import { FaEye, FaEyeSlash, FaRegTrashAlt } from 'react-icons/fa'

import {
  Btn,
  BtnIcon,
  CustomCalendar,
  CustomCheckbox,
  CustomDataTable,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  CustomTabView,
  InputNumeroInteiro,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import * as XmlRobotConfigHttp from '../../../../services/api/https/settings/xml-robot-config.http'
import XmlImportLogTab from './XmlImportLogTab'

const INIT_SERVER = {
  id: null,
  nome: '',
  host: '',
  password: '',
  user: '',
  port: '',
  files_path: '',
  type: 'FTP',
  secure: false,
  zipped: false,
}

const FTP_TYPES = [
  { id: 'FTP', name: 'FTP' },
  { id: 'SFTP', name: 'SFTP' },
]

const INIT_EMAIL_RECEIVER = {
  id: null,
  name: '',
  inbox_name: '',
  user: '',
  password: '',
  host: '',
  port: '993',
  tls: true,
  start_point_to_fetch: null,
  last_email_uuid: '',
}

function ConfiguracoesRoboXml({ dispatch, history }) {
  const [isLoading, setIsLoading] = useState(true)
  const [servers, setServers] = useState([])
  const [showModal, setShowModal] = useState({ show: false, data: { ...INIT_SERVER } })
  const [globalFilter, setGlobalFilter] = useState('')
  const [activeIndex, setActiveIndex] = useState(0)

  // Email state
  const [isLoadingEmail, setIsLoadingEmail] = useState(true)
  const [emailReceivers, setEmailReceivers] = useState([])
  const [showEmailModal, setShowEmailModal] = useState({ show: false, data: { ...INIT_EMAIL_RECEIVER } })
  const [emailGlobalFilter, setEmailGlobalFilter] = useState('')

  async function fetchServers() {
    try {
      const response = await XmlRobotConfigHttp.getFtpServers()
      setServers(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  async function fetchEmailReceivers() {
    try {
      const response = await XmlRobotConfigHttp.getEmailReceivers()
      setEmailReceivers(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoadingEmail(false)
    }
  }

  useEffect(() => {
    fetchServers()
    fetchEmailReceivers()
  }, [])

  const openNewModal = () => {
    setShowModal({ show: true, data: { ...INIT_SERVER } })
  }

  const openEditModal = server => {
    if (!server) return
    setShowModal({ show: true, data: normalizeServer(server) })
  }

  const onModalClose = () => {
    setShowModal({ show: false, data: { ...INIT_SERVER } })
    fetchServers()
  }

  const openNewEmailModal = () => {
    setShowEmailModal({ show: true, data: { ...INIT_EMAIL_RECEIVER } })
  }

  const openEditEmailModal = receiver => {
    if (!receiver) return
    setShowEmailModal({ show: true, data: normalizeEmailReceiver(receiver) })
  }

  const onEmailModalClose = () => {
    setShowEmailModal({ show: false, data: { ...INIT_EMAIL_RECEIVER } })
    fetchEmailReceivers()
  }

  return (
    <React.Fragment>
      <PageHeader>S.32 - Configurações do Robô de leitura de XML</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <CustomTabView activeIndex={activeIndex} onTabChange={setActiveIndex}>
            <TabPanel header="FTP/SFTP">
              <div style={{ marginBottom: 10 }}>
                <Btn onClick={openNewModal}>Novo</Btn>
              </div>
              {isLoading ? (
                <div className="text-center">
                  <Loading size="md" />
                </div>
              ) : (
                <CustomDataTable
                  value={servers}
                  selectionMode="single"
                  onSelectionChange={e => openEditModal(e.value)}
                  paginator
                  rows={10}
                  globalFilter={globalFilter}
                  header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                >
                  <Column field="id" header="Código" style={tableCellCentered(80)} />
                  <Column field="nome" header="Nome" />
                </CustomDataTable>
              )}
            </TabPanel>
            <TabPanel header="Email">
              <div style={{ marginBottom: 10 }}>
                <Btn onClick={openNewEmailModal}>Novo</Btn>
              </div>
              {isLoadingEmail ? (
                <div className="text-center">
                  <Loading size="md" />
                </div>
              ) : (
                <CustomDataTable
                  value={emailReceivers}
                  selectionMode="single"
                  onSelectionChange={e => openEditEmailModal(e.value)}
                  paginator
                  rows={10}
                  globalFilter={emailGlobalFilter}
                  header={<CustomDataTableHeader onChange={setEmailGlobalFilter} />}
                >
                  <Column field="id" header="Código" style={tableCellCentered(80)} />
                  <Column field="name" header="Nome" />
                </CustomDataTable>
              )}
            </TabPanel>
            <TabPanel header="LOGs">
              <XmlImportLogTab
                fetchLogs={(pInicial, pFinal) =>
                  XmlRobotConfigHttp.getXmlImportLogs(pInicial, pFinal)
                }
                downloadLog={logId => XmlRobotConfigHttp.downloadXmlImportLog(logId)}
                showMessageBox={(msgOk, msgNok) => dispatch(showMessageBox(msgOk, msgNok))}
              />
            </TabPanel>
          </CustomTabView>
        </CustomPanel>
      </div>
      {showModal.show ? (
        <FtpServerModal
          dispatch={dispatch}
          show={showModal.show}
          data={showModal.data}
          onClose={onModalClose}
          onSaved={fetchServers}
        />
      ) : null}
      {showEmailModal.show ? (
        <EmailReceiverModal
          dispatch={dispatch}
          show={showEmailModal.show}
          data={showEmailModal.data}
          onClose={onEmailModalClose}
          onSaved={fetchEmailReceivers}
        />
      ) : null}
    </React.Fragment>
  )
}

function FtpServerModal({ dispatch, show, data, onClose, onSaved }) {
  const [server, setServer] = useState({ ...INIT_SERVER })
  const [activeIndex, setActiveIndex] = useState(0)
  const [companies, setCompanies] = useState([])
  const [tpsOptions, setTpsOptions] = useState([])
  const [companiesOptions, setCompaniesOptions] = useState([])
  const [selectedTp, setSelectedTp] = useState(null)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (!show) return

    const nextServer = normalizeServer(data)
    setServer(nextServer)
    setActiveIndex(0)
    setSelectedTp(null)
    setSelectedCompany(null)
    setShowPassword(false)
    loadOptions()

    if (nextServer.id) {
      loadCompanies(nextServer.id)
    } else {
      setCompanies([])
    }
  }, [show, data])

  async function loadOptions() {
    try {
      const [tps, activeCompanies] = await Promise.all([
        XmlRobotConfigHttp.getActiveTps(),
        XmlRobotConfigHttp.getActiveCompanies(),
      ])

      setTpsOptions(tps.map(buildOptionLabel))
      setCompaniesOptions(activeCompanies.map(buildOptionLabel))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    }
  }

  async function loadCompanies(ftpServerId) {
    try {
      setIsLoadingCompanies(true)
      const response = await XmlRobotConfigHttp.getFtpServerCompanies(ftpServerId)
      setCompanies(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoadingCompanies(false)
    }
  }

  function onChange(field, value) {
    setServer(prevServer => ({
      ...prevServer,
      [field]: value,
    }))
  }

  async function onSaveServer() {
    try {
      dispatch(showLoadingBox('Aguarde...'))
      const saved = await XmlRobotConfigHttp.saveFtpServer(buildServerPayload(server))
      const normalized = normalizeServer(saved)
      setServer(normalized)
      setActiveIndex(0)
      await onSaved()

      if (!server.id) {
        await loadCompanies(normalized.id)
      }
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  async function onAddCompany() {
    if (!server.id) {
      return dispatch(showMessageBox(null, 'Salve a conexão antes de adicionar empresas'))
    }
    if (!selectedTp) {
      return dispatch(showMessageBox(null, 'Selecione um Operador Logístico'))
    }
    if (!selectedCompany) {
      return dispatch(showMessageBox(null, 'Selecione uma Empresa'))
    }

    try {
      dispatch(showLoadingBox('Aguarde...'))
      const saved = await XmlRobotConfigHttp.saveFtpServerCompany(server.id, {
        tp_id: selectedTp.id,
        company_id: selectedCompany.id,
      })
      setCompanies(prevCompanies => [...prevCompanies, saved])
      setSelectedTp(null)
      setSelectedCompany(null)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  async function onDeleteCompany(company) {
    try {
      dispatch(showLoadingBox('Aguarde...'))
      await XmlRobotConfigHttp.deleteFtpServerCompany(company.id)
      setCompanies(prevCompanies => prevCompanies.filter(item => item.id !== company.id))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  return (
    <CustomModal
      width={900}
      header="Configurar conexão FTP/SFTP"
      isVisible={show}
      onClose={onClose}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={setActiveIndex}>
        <TabPanel header="Conexão">
          <div className="p-grid">
            <div className="p-col-12">
              <InputText
                label="Nome da conexão"
                name="xml_robot_connection_name"
                autoComplete="off"
                value={server.nome}
                onChange={value => onChange('nome', value)}
              />
            </div>
            <div className="p-col-12">
              <Fieldset legend="Login">
                <div className="p-grid">
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label="Host"
                      name="xml_robot_host"
                      autoComplete="off"
                      marginTop={0}
                      value={server.host}
                      onChange={value => onChange('host', value)}
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <InputNumeroInteiro
                      label="Porta"
                      marginTop={0}
                      value={server.port}
                      onChange={value => onChange('port', value)}
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label="Usuário"
                      name="xml_robot_ftp_user"
                      autoComplete="new-password"
                      value={server.user}
                      onChange={value => onChange('user', value)}
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <div style={{ position: 'relative' }}>
                      <InputText
                        label="Senha"
                        name="xml_robot_ftp_password"
                        autoComplete="new-password"
                        type={showPassword ? 'text' : 'password'}
                        value={server.password}
                        onChange={value => onChange('password', value)}
                        inputStyle={{
                          width: '100%',
                          paddingRight: '32px',
                        }}
                      />

                      <span
                        onClick={() => setShowPassword(prev => !prev)}
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: 'calc(50% + 12px)',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 2,
                          fontSize: '1.1rem',
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-md-8 p-col-12">
              <InputText
                label="Caminho dos arquivos"
                name="xml_robot_files_path"
                autoComplete="off"
                value={server.files_path}
                onChange={value => onChange('files_path', value)}
              />
            </div>
            <div className="p-md-4 p-col-12">
              <CustomDropdown
                label="Tipo"
                optionLabel="name"
                options={FTP_TYPES}
                value={FTP_TYPES.find(type => type.id === server.type)}
                onChange={value => onChange('type', value.id)}
              />
            </div>
            <div className="p-md-6 p-col-12" style={{ marginTop: 20 }}>
              <CustomCheckbox
                checked={parseBoolean(server.secure)}
                onChange={value => onChange('secure', value)}
              >
                Conexão segura/TLS?
              </CustomCheckbox>
            </div>
            <div className="p-md-6 p-col-12" style={{ marginTop: 20 }}>
              <CustomCheckbox
                checked={parseBoolean(server.zipped)}
                onChange={value => onChange('zipped', value)}
              >
                Arquivos em .zip ou .rar?
              </CustomCheckbox>
            </div>
            <div className="p-col-12">
              <Btn onClick={onSaveServer}>Salvar</Btn>
            </div>
          </div>
        </TabPanel>
        <TabPanel disabled={!server.id} header="Empresas">
          <div className="p-grid">
            <div className="p-md-5 p-col-12">
              <CustomDropdown
                label="Operador Logístico"
                optionLabel="label"
                filter
                options={tpsOptions}
                value={selectedTp}
                onChange={setSelectedTp}
                placeholder="Selecione"
              />
            </div>
            <div className="p-md-5 p-col-12">
              <CustomDropdown
                label="Empresa"
                optionLabel="label"
                filter
                options={companiesOptions}
                value={selectedCompany}
                onChange={setSelectedCompany}
                placeholder="Selecione"
              />
            </div>
            <div className="p-md-2 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Btn style={{ marginBottom: 0 }} onClick={onAddCompany}>
                Adicionar
              </Btn>
            </div>
            <div className="p-col-12">
              {isLoadingCompanies ? (
                <div className="text-center">
                  <Loading size="md" />
                </div>
              ) : (
                <CustomDataTable value={companies} paginator rows={5}>
                  <Column
                    header="Operador Logístico"
                    body={row => `${row.tp_id} - ${row.tp_name}`}
                  />
                  <Column
                    header="Empresa"
                    body={row => `${row.company_id} - ${row.company_name}`}
                  />
                  <Column
                    header=""
                    style={tableCellCentered(80)}
                    body={row => (
                      <BtnIcon onClick={() => onDeleteCompany(row)}>
                        <FaRegTrashAlt color="red" size={18} />
                      </BtnIcon>
                    )}
                  />
                </CustomDataTable>
              )}
            </div>
          </div>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

function normalizeServer(server) {
  return {
    ...INIT_SERVER,
    ...(server || {}),
    secure: parseBoolean(server && server.secure),
    zipped: parseBoolean(server && server.zipped),
    port: server && server.port ? String(server.port) : '',
  }
}

function buildOptionLabel(item) {
  return {
    ...item,
    label: `${item.id} - ${item.name}`,
  }
}

function buildServerPayload(server) {
  return {
    ...server,
    port: Number(server.port),
    secure: parseBoolean(server.secure),
    zipped: parseBoolean(server.zipped),
  }
}

function EmailReceiverModal({ dispatch, show, data, onClose, onSaved }) {
  const [receiver, setReceiver] = useState({ ...INIT_EMAIL_RECEIVER })
  const [activeIndex, setActiveIndex] = useState(0)
  const [senders, setSenders] = useState([])
  const [tpsOptions, setTpsOptions] = useState([])
  const [companiesOptions, setCompaniesOptions] = useState([])
  const [selectedTp, setSelectedTp] = useState(null)
  const [selectedCompany, setSelectedCompany] = useState(null)
  const [emailFrom, setEmailFrom] = useState('')
  const [isLoadingSenders, setIsLoadingSenders] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  useEffect(() => {
    if (!show) return

    const nextReceiver = normalizeEmailReceiver(data)
    setReceiver(nextReceiver)
    setActiveIndex(0)
    setSelectedTp(null)
    setSelectedCompany(null)
    setEmailFrom('')
    setShowPassword(false)
    loadOptions()

    if (nextReceiver.id) {
      loadSenders(nextReceiver.id)
    } else {
      setSenders([])
    }
  }, [show, data])

  async function loadOptions() {
    try {
      const [tps, activeCompanies] = await Promise.all([
        XmlRobotConfigHttp.getActiveTps(),
        XmlRobotConfigHttp.getActiveCompanies(),
      ])

      setTpsOptions(tps.map(buildOptionLabel))
      setCompaniesOptions(activeCompanies.map(buildOptionLabel))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    }
  }

  async function loadSenders(receiverId) {
    try {
      setIsLoadingSenders(true)
      const response = await XmlRobotConfigHttp.getEmailReceiverSenders(receiverId)
      setSenders(response)
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      setIsLoadingSenders(false)
    }
  }

  function onChange(field, value) {
    setReceiver(prevReceiver => ({
      ...prevReceiver,
      [field]: value,
    }))
  }

  async function onSaveReceiver() {
    try {
      dispatch(showLoadingBox('Aguarde...'))
      const saved = await XmlRobotConfigHttp.saveEmailReceiver(buildEmailReceiverPayload(receiver))
      const normalized = normalizeEmailReceiver(saved)
      setReceiver(normalized)
      setActiveIndex(0)
      await onSaved()

      if (!receiver.id) {
        await loadSenders(normalized.id)
      }
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  async function onAddSender() {
    if (!receiver.id) {
      return dispatch(showMessageBox(null, 'Salve a conexão antes de adicionar empresas'))
    }
    if (!selectedTp) {
      return dispatch(showMessageBox(null, 'Selecione um Operador Logístico'))
    }
    if (!selectedCompany) {
      return dispatch(showMessageBox(null, 'Selecione uma Empresa'))
    }
    if (!emailFrom || !emailFrom.trim()) {
      return dispatch(showMessageBox(null, 'Informe o Email Remetente'))
    }

    try {
      dispatch(showLoadingBox('Aguarde...'))
      const saved = await XmlRobotConfigHttp.saveEmailReceiverSender(receiver.id, {
        tp_id: selectedTp.id,
        company_id: selectedCompany.id,
        email_from: emailFrom.trim(),
      })
      setSenders(prevSenders => [...prevSenders, saved])
      setSelectedTp(null)
      setSelectedCompany(null)
      setEmailFrom('')
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  async function onDeleteSender(sender) {
    try {
      dispatch(showLoadingBox('Aguarde...'))
      await XmlRobotConfigHttp.deleteEmailSender(sender.id)
      setSenders(prevSenders => prevSenders.filter(item => item.id !== sender.id))
    } catch (error) {
      dispatch(showMessageBox(null, error))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  return (
    <CustomModal
      width={900}
      header="Configurar conexão por Email"
      isVisible={show}
      onClose={onClose}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={setActiveIndex}>
        <TabPanel header="Conexão">
          <div className="p-grid">
            <div className="p-md-6 p-col-12">
              <InputText
                label="Nome da conexão"
                name="xml_robot_email_name"
                autoComplete="off"
                value={receiver.name}
                onChange={value => onChange('name', value)}
              />
            </div>
            <div className="p-md-6 p-col-12">
              <InputText
                label="Nome da Caixa de Entrada"
                name="xml_robot_email_inbox_name"
                autoComplete="off"
                value={receiver.inbox_name}
                onChange={value => onChange('inbox_name', value)}
              />
            </div>
            <div className="p-col-12">
              <Fieldset legend="Credenciais">
                <div className="p-grid">
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label="Email"
                      name="xml_robot_email_user"
                      autoComplete="new-password"
                      marginTop={0}
                      value={receiver.user}
                      onChange={value => onChange('user', value)}
                    />
                  </div>
                  <div className="p-md-6 p-col-12">
                    <div style={{ position: 'relative' }}>
                      <InputText
                        label="Senha"
                        name="xml_robot_email_password"
                        autoComplete="new-password"
                        type={showPassword ? 'text' : 'password'}
                        marginTop={0}
                        value={receiver.password}
                        onChange={value => onChange('password', value)}
                        inputStyle={{
                          width: '100%',
                          paddingRight: '32px',
                        }}
                      />
                      <span
                        onClick={() => setShowPassword(prev => !prev)}
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: 'calc(50% + 12px)',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          zIndex: 2,
                          fontSize: '1.1rem',
                        }}
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                  <div className="p-md-6 p-col-12">
                    <InputText
                      label="Host"
                      name="xml_robot_email_host"
                      autoComplete="off"
                      value={receiver.host}
                      onChange={value => onChange('host', value)}
                    />
                  </div>
                  <div className="p-md-4 p-col-12">
                    <InputNumeroInteiro
                      label="Porta"
                      value={receiver.port}
                      onChange={value => onChange('port', value)}
                    />
                  </div>
                  <div className="p-md-2 p-col-12" style={{ display: 'flex', alignItems: 'flex-end', marginTop: 20 }}>
                    <CustomCheckbox
                      checked={parseBoolean(receiver.tls)}
                      onChange={value => onChange('tls', value)}
                    >
                      Conexão Segura/TLS?
                    </CustomCheckbox>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-md-6 p-col-12">
              <CustomCalendar
                label="Data de início do processamento de emails"
                value={receiver.start_point_to_fetch}
                onChange={value => onChange('start_point_to_fetch', value)}
              />
            </div>
            <div className="p-md-6 p-col-12" style={{  marginTop: -10 }}>
              {receiver.id ? (
                <InputText
                  label="Último id de email processado"
                  value={receiver.last_email_uuid}
                  disabled
                />
              ) : (
                <InputNumeroInteiro
                  label="Último id de email processado"
                  value={receiver.last_email_uuid}
                  onChange={value => onChange('last_email_uuid', value)}
                />
              )}
            </div>
            <div className="p-col-12">
              <Btn onClick={onSaveReceiver}>Salvar</Btn>
            </div>
          </div>
        </TabPanel>
        <TabPanel disabled={!receiver.id} header="Empresas">
          <div className="p-grid">
            <div className="p-md-6 p-col-12">
              <CustomDropdown
                label="Operador Logístico"
                optionLabel="label"
                filter
                options={tpsOptions}
                value={selectedTp}
                onChange={setSelectedTp}
                placeholder="Selecione"
              />
            </div>
            <div className="p-md-6 p-col-12">
              <CustomDropdown
                label="Empresa"
                optionLabel="label"
                filter
                options={companiesOptions}
                value={selectedCompany}
                onChange={setSelectedCompany}
                placeholder="Selecione"
              />
            </div>
            <div className="p-md-6 p-col-12">
              <InputText
                label="Email Remetente"
                name="xml_robot_email_from"
                autoComplete="off"
                value={emailFrom}
                onChange={setEmailFrom}
              />
            </div>
            <div className="p-md-3 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
              <Btn style={{ marginBottom: 0 }} onClick={onAddSender}>
                Adicionar
              </Btn>
            </div>
            <div className="p-col-12">
              {isLoadingSenders ? (
                <div className="text-center">
                  <Loading size="md" />
                </div>
              ) : (
                <CustomDataTable value={senders} paginator rows={5}>
                  <Column
                    header="Operador Logístico"
                    body={row => `${row.tp_id} - ${row.tp_name}`}
                  />
                  <Column
                    header="Empresa"
                    body={row => `${row.company_id} - ${row.company_name}`}
                  />
                  <Column
                    field="email_from"
                    header="Email Remetente"
                  />
                  <Column
                    header=""
                    style={tableCellCentered(80)}
                    body={row => (
                      <BtnIcon onClick={() => onDeleteSender(row)}>
                        <FaRegTrashAlt color="red" size={18} />
                      </BtnIcon>
                    )}
                  />
                </CustomDataTable>
              )}
            </div>
          </div>
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

function normalizeEmailReceiver(receiver) {
  let startPointDate = null
  if (receiver && receiver.start_point_to_fetch) {
    const raw = String(receiver.start_point_to_fetch).substring(0, 10)
    const [year, month, day] = raw.split('-').map(Number)
    if (year && month && day) {
      startPointDate = new Date(year, month - 1, day)
    }
  }
  return {
    ...INIT_EMAIL_RECEIVER,
    ...(receiver || {}),
    tls: parseBoolean(receiver && receiver.tls),
    port: receiver && receiver.port ? String(receiver.port) : '993',
    start_point_to_fetch: startPointDate,
    last_email_uuid: receiver && receiver.last_email_uuid ? String(receiver.last_email_uuid) : '',
  }
}

function buildEmailReceiverPayload(receiver) {
  let startPointStr = null
  if (receiver.start_point_to_fetch instanceof Date) {
    const d = receiver.start_point_to_fetch
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    startPointStr = `${yyyy}-${mm}-${dd}`
  }
  return {
    ...receiver,
    port: Number(receiver.port),
    tls: parseBoolean(receiver.tls),
    last_email_uuid: receiver.id
      ? undefined
      : receiver.last_email_uuid
      ? Number(receiver.last_email_uuid)
      : null,
    start_point_to_fetch: startPointStr,
  }
}

function parseBoolean(value) {
  return value === true || value === 1 || value === '1'
}

export default connect()(withRouter(ConfiguracoesRoboXml))
